import { Component } from '@angular/core';
import {ModalRef} from "../../../../tandem-core/models/modal-ref";

@Component({
  selector: 'tandem-pc-disclosure',
  templateUrl: './pc-disclosure.component.html',
  styleUrls: ['./pc-disclosure.component.scss']
})
export class PcDisclosureComponent {

  public modalRef?: ModalRef;

  close() {
    this.modalRef?.close();
  }
}
